import React from "react";

const ContactForm = () => {
    return (
        <section className="text-white py-12 px-4">
        <div className="max-w-3xl mx-auto">
        <h2 className="text-3xl font-bold mb-6 text-center">Contact Me</h2>
        <form
          name="contact"
          method="POST"
          data-netlify="true"
          className="space-y-6 bg-gray-800 p-6 rounded-xl shadow-lg"
        >
          <input type="hidden" name="form-name" value="contact" />
          
          <div>
            <label className="block text-sm mb-1">Name</label>
            <input
              type="text"
              name="name"
              required
              className="w-full px-4 py-2 bg-gray-700 border border-gray-600 rounded"
              placeholder="Your name"
            />
          </div>

          <div>
            <label className="block text-sm mb-1">Email</label>
            <input
              type="email"
              name="email"
              required
              className="w-full px-4 py-2 bg-gray-700 border border-gray-600 rounded"
              placeholder="you@example.com"
            />
          </div>

          <div>
            <label className="block text-sm mb-1">Message</label>
            <textarea
              name="message"
              required
              rows="5"
              className="w-full px-4 py-2 bg-gray-700 border border-gray-600 rounded"
              placeholder="Type your message here..."
            ></textarea>
          </div>

          <button
            type="submit"
            className="rounded-xl text-sm font-medium border border-orange-400 bg-gray-800 text-white px-4 py-2 hover:bg-gray-700 transition-all duration-200 hover:bg-orange-500 hover:text-black"
          >
            Send Message
          </button>
        </form>
      </div>
    </section>
    );
};

export default ContactForm;